import { ClimateAction } from "@/domain/climate-action/models/climate-action";
import { Project } from "@/domain/project/models/project-model";
import { Task } from "@/domain/task/models/task-model";
import { type OwnerType, ownerTypeFromString, OwnerTypes } from "@ark/shared";

export { ownerTypeFromString, OwnerTypes };
export type { OwnerType };

export const OwnedItemTypes = {
  ...OwnerTypes,
  INDICATOR: "INDICATOR",
} as const;

export type Owner = ClimateAction | Project | Task;
export type OwnedItemType = OwnerType | "INDICATOR";
